import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "src/components/layout/Header";
import BaseFullModal from "src/components/BaseFullModal";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";

// 모달 Props 타입 정의
type Props = {
  type: string; // 모달 타입
  onClose: any; // 닫기 핸들러
};

// 모달 타입 정의
type ModalType = {
  type: string; // 모달 식별자
  label: string; // 모달 제목
  url: string; // 표시할 URL (국문)
  enUrl?: string; // 영문 URL. 외부 가이드라인 사이트(guidelines.taapspace.kr)에 영문 페이지가 없어 미연결 상태.
};

// 모달 타입 목록
// TODO(MVDV-9054): 외부 가이드라인 사이트에 영문 페이지가 발급되면 각 항목의 enUrl 을 채운다.
//   현재 외부 사이트는 국문만 서빙하며 lang 파라미터/영문 경로가 없어 iframe 본문은 국문으로 표시된다.
const modalType: Array<ModalType> = [
  { type: "receipt", label: "현금영수증 및 세금계산서 발급 안내", url: "https://guidelines.taapspace.kr/terms/taapspace/receipt" },
  { type: "reservation", label: "개인정보 제3자 제공 동의", url: "https://guidelines.taapspace.kr/terms/taapspace/privacy-policy/space-reservation" },
  {
    type: "support",
    label: "개인정보 수집 및 이용동의",
    url: "https://guidelines.taapspace.kr/terms/taapspace/privacy-policy/customer-support",
  },
];

// 노션 모달 컴포넌트
// 외부 URL을 iframe으로 표시하는 모달 컴포넌트
const NotionModalComponent = () => {
  const { t, i18n } = useTranslation("contract");
  // 네비게이션 및 위치 정보
  const location = useLocation();
  const navigate = usePartnerNavigate();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");

  // 모달 닫기 핸들러
  const onClose = () => {
    navigate(-1);
  };

  // 모달 데이터 상태 관리
  const [modalData, setModalData] = useState<ModalType>();

  // URL 파라미터에 따른 모달 데이터 설정
  useEffect(() => {
    const data = modalType.find((item) => item.type === type);
    setModalData(data);
  }, [type]);

  return (
    <div className="contract-page">
      {/* 헤더 컴포넌트 */}
      <Header
        headerType="BACK"
        title={modalData?.type === "receipt" ? t("guide.receiptGuide") : modalData?.label}
        onClickBackButton={() => {
          onClose()!;
        }}
      />

      {/* iframe으로 URL 내용 표시. 영문이고 영문 URL(enUrl)이 있으면 영문 페이지, 없으면 국문 페이지로 폴백 */}
      <div className="notion-modal">
        <iframe
          src={i18n.language?.startsWith("en") && modalData?.enUrl ? modalData.enUrl : modalData?.url}
          className="notion-modal__iframe"
        ></iframe>
      </div>
    </div>
  );
};

export default NotionModalComponent;
